import { createApp } from 'vue';
import { createI18n } from "vue-i18n";
import App from './App.vue';
import router from './router';
import store from "@/core/services/store";
import ApiService from "@/core/services/api.service";
import Maska from "maska";

import ptBR from "./locales/ptBR.json";
import en from "./locales/en.json";
import es from "./locales/es.json";

const i18n = createI18n({
    locale: "ptBR",
    fallbackLocale: "ptBR",
    messages: { ptBR, en, es }
});

const AppVue = createApp(App);
AppVue.use(i18n);

ApiService.init();

AppVue.use(router);
AppVue.use(store);
AppVue.use(Maska);
AppVue.mount('#app');